import React from 'react';
import { Tooltip, Card } from 'antd';

const Hint = (props) => {
    const { title, children } = props;

    return (
        <Tooltip
            destroyTooltipOnHide={{ keepParent: false }}
            placement="bottom"
            overlayClassName="table-tooltip"
            title={!!title && (
                <Card
                    className="text-sm text-white bg-gray-dark02"
                    bodyStyle={{ padding: '4px 8px' }}
                >
                    {title}
                </Card>
            )}
        >
            {children}
        </Tooltip>
    );
};

export default Hint;
